import {
  Flex, Text, VStack,
} from '@chakra-ui/react';
import { get } from '@submize/lodash';
import { useDispatch } from 'react-redux';
import { setLayoutStyles } from '../../formSlice';
import InputSetting from '../../../InputSetting';
import ColorPicker from '../../../ColorPicker/ColorPicker';

export const borderStyleOptions = [
  { key: 'none', value: 'None' },
  { key: 'solid', value: 'Solid' },
  { key: 'dotted', value: 'Dotted' },
  { key: 'dashed', value: 'Dashed' },
  { key: 'inset', value: 'Inset' },
];

const LayoutStyles = ({ design }) => {
  const dispatch = useDispatch();

  return (
    <VStack color="gray.600" fontSize="sm" gap="3">
      <Text fontWeight="bold">Form</Text>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Padding vertical"
          value={get(design, 'layout.paddingY', '12px')}
          onChange={(v) => dispatch(setLayoutStyles({ paddingY: v }))}
          regex={/(^[0-9]+ ?px)?$/}
          errorMessage="Width must be in px"
        />
      </Flex>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Padding horizontal"
          value={get(design, 'layout.paddingX', '10px')}
          onChange={(v) => dispatch(setLayoutStyles({ paddingX: v }))}
          regex={/(^[0-9]+ ?px)?$/}
          errorMessage="Width must be in px"
        />
      </Flex>
      <Text fontWeight="bold">Page</Text>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Margin top"
          value={get(design, 'layout.marginTop', '')}
          onChange={(v) => dispatch(setLayoutStyles({ marginTop: v }))}
          regex={/(^[0-9]+ ?px)?$/}
          errorMessage="Width must be in px"
        />
      </Flex>
      <Flex justify="space-between" w="100%">
        <InputSetting
          label="Margin bottom"
          value={get(design, 'layout.marginBottom', '')}
          onChange={(v) => dispatch(setLayoutStyles({ marginBottom: v }))}
          regex={/(^[0-9]+ ?px)?$/}
          errorMessage="Width must be in px"
        />
      </Flex>
      <Flex justify="space-between" w="100%">
        <Text>Background color</Text>
        <ColorPicker
          color={get(design, 'layout.backgroundColor', '#fff')}
          onChange={(c) => dispatch(setLayoutStyles({ backgroundColor: c }))}
        />
      </Flex>
    </VStack>
  );
};

export default LayoutStyles;
